const imageCount = 57;

export const CarouselImages = {
  subTitle: {
    first: "Pilot Project",
  },
  title: "Residential Retrofit Pilot Project",
  images: Array.from({ length: imageCount }, (_, index) => ({
    id: index + 1,
    name: `image${index + 1}`,
    url: `assets/images/jpg/carouselimg/image${index + 1}.png`
  })),
};

export default CarouselImages;
